export default {
    Normal: 1,
    Result: 2
}
